import { render, staticRenderFns } from "./MSADocumentSent.vue?vue&type=template&id=04279c0f&"
import script from "./MSADocumentSent.vue?vue&type=script&lang=js&"
export * from "./MSADocumentSent.vue?vue&type=script&lang=js&"
import style0 from "./MSADocumentSent.vue?vue&type=style&index=0&id=04279c0f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports